<template>
  <div class="contaniner">
    <van-search
      v-model="hostUnit"
      placeholder="请输入通知公告标题"
      @input="searchTap"
    />
    <van-list
      v-if="listShow"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      offset="10"
      @load="onLoad"
    >
      <div
        class="list-wrap"
        v-for="(item, index) in lists"
        :key="index"
        @click="listTap(item.id)"
      >
        <div class="list-title">{{ item.informTitle }}</div>
        <div class="list-info">
          <div class="list-time">发布时间：{{ item.createTime }}</div>
          <div class="list-part">{{ item.creator }}</div>
        </div>
      </div>
    </van-list>
    <van-empty
      v-else
      class="custom-image"
      image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
      description="暂无数据"
    />
  </div>
</template>
<script>
import { getListPage, getDetail } from '@api/lishui/notice'
import { newSaveRecord, newSaveUVRecord } from '@api/lishui'
import { getToken } from '@utils'
import { Toast } from 'vant'
import { getLocalStorage } from '@utils'
export default {
  data() {
    return {
      hostUnit: '',
      loading: true,
      finished: false,
      listShow: true,
      lists: [],
      pageSize: 10,
      pageNum: 1,
      userInfo: {}
    }
  },
  mounted() {
    if (getToken()) {
      this.getList()
    }
    this.userInfo = getLocalStorage('lishuiUserInfo')
      ? JSON.parse(getLocalStorage('lishuiUserInfo'))
      : {}
  },
  methods: {
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title,
        creditCode: this.userInfo.creditCode,
        entName: this.userInfo.entName,
        mobile: this.userInfo.mobile
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      newSaveRecord(params).then(res => {})
      newSaveUVRecord(params).then(res => {})
    },
    getList(num) {
      if (num) {
        this.pageNum = num
        this.lists = []
      }
      const params = {
        key: this.hostUnit,
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }
      getListPage(params).then(res => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          if (data.results) {
            data.results.forEach(item => {
              item.createTime = item.createTime.split(' ')[0]
              this.lists.push(item)
            })
          }
          this.loading = false
          if (!data.results || data.results.length < this.pageSize) {
            this.finished = true
          } else {
            this.finished = false
          }
          if (this.lists.length == 0) {
            this.listShow = false
          } else {
            this.listShow = true
          }
        } else {
          Toast(msg)
        }
      })
    },
    // 搜索
    searchTap(e) {
      this.getList(1)
    },
    // 触底加载更多
    onLoad() {
      this.pageNum++
      this.getList()
    },
    listTap(id) {
      this.buriedPoint()
      this.$router.push({
        path: '/notice/details',
        query: {
          id: id
        }
      })
      let params = {
        id
      }
      getDetail(params).then(res => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.van-search {
  padding: 10px 0.4rem 0 0.4rem;
  width: 100%;
  z-index: 10;
  position: sticky;
  top: 0;
  background: #fff;

  .van-search__content {
    border-radius: 20px;
  }
  /deep/.van-cell__value {
    padding: 0 4px;
  }
}
.list-wrap {
  padding: 15px 15px 15px 36px;
  border-bottom: 1px solid #eee;
  position: relative;
  &::before {
    content: '';
    display: block;
    width: 18px;
    height: 18px;
    background: url('../../../assets/notice.png') center no-repeat;
    background-size: cover;
    position: absolute;
    top: 18px;
    left: 12px;
  }
  .list-title {
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .list-info {
    display: flex;
    margin-top: 6px;
    .list-time,
    .list-part {
      font-size: 16px;
      color: #666;
      margin-right: 10px;
      white-space: nowrap;
      overflow: hidden;
    }
    .list-part {
      flex: 1;
      text-overflow: ellipsis;
    }
  }
}
/deep/.custom-image .van-empty__image {
  width: 90px;
  height: 90px;
  margin-top: 20%;
}
</style>
